













































import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    adminFee: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    displayFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      donationAmount: this.value,
      hideFee: true
    };
  },
  computed: {
    totalAmountCalculated(): number | null {
      const donationAmount: number = parseFloat(this.donationAmount);
      if (
        this.min <= donationAmount &&
        donationAmount <= this.max
      ) {
        return donationAmount + this.adminFee;
      }
      return null;
    },
  },
  watch: {
    donationAmount(value) {
      this.$emit('input', value);
    },
    adminFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    displayFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee
    },
    value(newVal) {
      this.donationAmount = newVal;
    }
  },
  mounted(){
    this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
  },
  methods: {
    t(label: string): string {
      const $te: any = (this as any).$te.bind(this);
      const $t: any = (this as any).$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
